/* ==========================================================================
   Smooth scrolling (Lenis, as on the Lumina site)

   Mouse-wheel and trackpad scrolling ease to a stop instead of stepping,
   kept subtle: close to native, just a soft finish.
   Touch scrolling on phones and tablets stays native. Kept in step with
   GSAP: Lenis runs on GSAP's ticker and tells ScrollTrigger about every
   scroll, so the homepage hero pin and the scroll animations stay exact.

   Left alone:
   - Panels that scroll on their own (mini cart, phone menu, search
     results, dropdowns, the account pop-up): the wheel scrolls them
     natively, not the page behind.
   - While the mini cart or the account pop-up is open, the page doesn't
     scroll at all.
   - Sideways swipes on carousels stay native (Lenis only handles vertical).

   Skipped with reduced motion, or if Lenis didn't load.
   ========================================================================== */

(function () {
  'use strict';

  if (typeof window.Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var NATIVE = '#mini-cart, .cart-contents, .mobile-menu, #predictive-search-results, ' +
    '.custom-select-options, .header-dropdown, .account-modal, [data-lenis-prevent]';

  // Subtle: lerp nearer 1 = less glide (Lumina uses 0.085); normal wheel speed
  var lenis = new Lenis({
    lerp: 0.2,
    wheelMultiplier: 1,
    smoothWheel: true,
    prevent: function (node) {
      return !!(node && node.closest && node.closest(NATIVE));
    }
  });
  window.__lenis = lenis;

  if (window.gsap) {
    if (window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      lenis.on('scroll', ScrollTrigger.update);
    }
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
  } else {
    (function frame(time) {
      lenis.raf(time);
      requestAnimationFrame(frame);
    })(performance.now());
  }

  // Hold the page still while the mini cart or the account pop-up is open
  var root = document.documentElement;
  function sync() {
    if (root.classList.contains('mini-cart-open') || root.classList.contains('account-modal-open')) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }
  new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });

  // The page's height changes as images load and sections reveal
  window.addEventListener('load', function () { lenis.resize(); });
})();
